/* eslint-disable no-unused-expressions */
import React, { useContext } from 'react'
import { useRouter } from 'next/router'
import { BenefitsTable, Faqs, Hero, ZigZag, PropValue, Quotes } from '@pcln/vip'
import { Box, Text, Divider, Relative } from 'pcln-design-system'
import Intro from './Intro'
import MemberCapture from './MemberCapture'
import AppDownload from '../AppDownload'
import EmailSignUp from '../EmailSignUp'
import analytics from '../../utils/analytics'
import { ANALYTICS_CATEGORY_VIP_LANDING } from '../../constants/analytics'
import data from './data'
import BootstrapDataContext from '../../context/BootstrapDataContext'

const imageSrc =
  'https://s1.pclncdn.com/design-assets/vip/miniCooper-lg-100.jpg'

const content = {
  headingText: 'Book more, save more.',
  text: 'Unlock huge savings, travel perks and more when you become a VIP.'
}

function gaFAQ() {
  analytics.fireEvent({
    action: 'vip faq',
    category: ANALYTICS_CATEGORY_VIP_LANDING,
    label: 'faq click'
  })
}

function gaBenefits(
  _action: string,
  _swipeDirection: string,
  activeTab: string
) {
  analytics.fireEvent({
    action: 'vip benefits grid',
    category: ANALYTICS_CATEGORY_VIP_LANDING,
    label: `${activeTab} tab`
  })
}

const openModal = (redirectToLoginPage: boolean) => () => {
  if (redirectToLoginPage) {
    window.location.href = '/profile/#/login?return-url=/vip'
  } else {
    window?.PCLN?.HeaderClient?.openModal()
  }
}

function gaZigZag(id: number) {
  analytics.fireEvent({
    action: 'vip faq',
    category: ANALYTICS_CATEGORY_VIP_LANDING,
    label: `zig zag ${id} button`
  })
}

const handleZigZagClick = (redirectToLoginPage: boolean) => (id: number) => {
  openModal(redirectToLoginPage)()
  gaZigZag(id)
}

export default function LandingPage() {
  const { isMobile = false, isTablet = false } = useContext(
    BootstrapDataContext
  )
  const {
    query: { NEGOTIATORAPP, negotiatorapp }
  } = useRouter()
  const isLoadedInAppView =
    NEGOTIATORAPP !== undefined || negotiatorapp !== undefined
  const redirectToLoginPage = isLoadedInAppView || isMobile || isTablet

  return (
    <Box>
      <Box color="background.light">
        <Hero imageSrc={imageSrc} content={content} />
        <Relative mt={[-6, null, 0]}>
          <Intro openModal={openModal(redirectToLoginPage)} />
        </Relative>
        <Box px={[2, null, null, null, 5]} pt={4} mx={[2, null, null, null, 5]}>
          <BenefitsTable navigationHandler={gaBenefits} />
        </Box>
        <Box px={3} pt={[5, null, null, null, 3]} mt="-160px">
          <Text textAlign="center" fontSize={0} color="text.light">
            *Trips are considered complete one day after the trip concludes
          </Text>
        </Box>
        <MemberCapture openModal={openModal(redirectToLoginPage)} />
        <PropValue {...data.valueProp} />
      </Box>
      <Box p={3} color="background.lightest">
        <ZigZag
          onClick={handleZigZagClick(redirectToLoginPage)}
          {...data.zigzag}
        />
        <Box mx={-3} py={5}>
          <Quotes
            showInCarouselMode={isMobile}
            maxWidth={1086}
            contents={data.quotes}
          />
        </Box>
        <Text mb={5} fontSize={5} textAlign="center" color="primary">
          Frequently Asked Questions
        </Text>
        <Box px={[2, null, null, null, 5]}>
          <Faqs onClick={gaFAQ} faqs={data.faqs} />
        </Box>
      </Box>
      {!isMobile && (
        <div>
          <Divider borderColor="border.base" my={0} />
          <EmailSignUp category={ANALYTICS_CATEGORY_VIP_LANDING} />
          <AppDownload category={ANALYTICS_CATEGORY_VIP_LANDING} />
          <Divider borderColor="border.base" my={0} />
        </div>
      )}
    </Box>
  )
}
